var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelsactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87503 3.3542C1.87222 3.15917 1.90857 2.96557 1.98191 2.78484C2.05525 2.60411 2.1641 2.43993 2.30201 2.30201C2.43993 2.1641 2.60411 2.05525 2.78484 1.98191C2.96557 1.90857 3.15917 1.87222 3.3542 1.87503L9.59419 1.9542C10.193 1.96144 10.7653 2.20283 11.1884 2.6267L17.2709 8.70836C17.6234 9.06086 17.9359 9.57003 18.0642 10.1142C18.1942 10.6675 18.1442 11.3442 17.6234 11.8642L11.865 17.6234C11.3442 18.1442 10.6675 18.1942 10.1142 18.0642C9.58284 17.9308 9.09722 17.6568 8.70836 17.2709L2.6267 11.1884C2.20358 10.7648 1.96233 10.1929 1.9542 9.59419L1.87503 3.3542ZM6.53503 5.26253C6.41655 5.15213 6.25984 5.09203 6.09793 5.09488C5.93601 5.09774 5.78152 5.16333 5.66701 5.27784C5.5525 5.39235 5.48691 5.54684 5.48405 5.70876C5.48119 5.87068 5.5413 6.02738 5.6517 6.14586L6.24086 6.73586C6.35879 6.84966 6.5167 6.91258 6.68057 6.91108C6.84444 6.90958 7.00117 6.84377 7.117 6.72784C7.23282 6.6119 7.29848 6.45511 7.29983 6.29124C7.30117 6.12737 7.2381 5.96952 7.1242 5.8517L6.53503 5.26253Z",
    fill: "#004A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelsactive);
export default __webpack_public_path__ + "static/media/labelsactive.a613d27848d29f6c5f7ada88213a49a9.svg";
export { ForwardRef as ReactComponent };